import React from 'react'
import ExpertsPage from '../parts/pages/ExpertsPage'

export default function Experts() {
  return <ExpertsPage />
}
